import React, { useState, useId } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [['How do I receive the package?', 'Immediate access as soon as your purchase is confirmed. Download and use it right away.'], ['What level is this for?', 'New instructors building confidence from day one and experienced instructors tired of planning from scratch. If you teach dance fitness, this was built for you.'], ['Does this work in any country?', 'Yes — it works for gyms, studios, community centers, schools, corporate wellness, or independent classes worldwide.'], ['Can I edit the material?', 'Yes. Everything is fully adaptable to your personal teaching style and your students.'], ['What format is it in?', 'PDF — professionally organized, printable, and ready to use with no extra software.'], ['What if it is not useful for me?', 'You have a full refund within 7 days. No questions asked.']];
export function FAQ() {
  const [open, setOpen] = useState(0);
  const baseId = useId();
  return <section className="bg-cloud px-4 py-20 sm:py-24" data-id="element-75">
      <div className="mx-auto max-w-3xl" data-id="element-76">
        <h2 className="mb-12 text-center font-display text-3xl font-black uppercase text-navy sm:text-5xl" data-id="element-77">
          Frequently asked <span className="text-violet" data-id="element-78">questions</span>
        </h2>
        <div className="space-y-3" data-id="element-79">
          {faqs.map(([question, answer], index) => {
          const isOpen = index === open;
          const panelId = `${baseId}-${index}`;
          return <article key={question} className="overflow-hidden rounded-xl border border-line bg-white" data-id="element-80">
                <h3 data-id="element-81">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? -1 : index)} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left text-base font-bold text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-violet" data-id="element-82">
                    <span data-id="element-83">{question}</span>
                    <ChevronDownIcon className={`shrink-0 text-violet transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-84" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-85">
                  {isOpen && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22
              }} data-id="element-86">
                      <p className="border-t border-line px-6 py-5 text-sm leading-relaxed text-slate-600" data-id="element-87">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}